import OwaWorkload from 'owa-workloads/lib/store/schema/OwaWorkload';
import { getBootType } from 'owa-config';
import { getOwaWorkload } from 'owa-workloads';
import { getWorkloadKeyResourceDWInfo } from './getWorkloadKeyResourceDWInfo';
import { isPWA } from 'mini-device-utils/lib/utils/isPWA';

import {
    getNetworkBootTypeUsingModulePing,
    NetworkBootType,
} from './getNetworkBootTypeUsingModulePing';

const payloadForBootAnalysis: { [key in OwaWorkload]?: Promise<any> } = {};

/**
 * Function to generate the payload used for LCP and LSR
 */
export const getPayloadForAppRenderBootAnalysis = () => {
    const workload = getOwaWorkload();

    if (!payloadForBootAnalysis[workload]) {
        payloadForBootAnalysis[workload] = getPayloadForAppRenderBootAnalysisInternal();
    }

    return payloadForBootAnalysis[workload];
};

const getPayloadForAppRenderBootAnalysisInternal = async () => {
    let networkBootType;
    let workloadKeyResourceDWInfo;
    let moduleNWBootTypeDetails: NetworkBootType;

    try {
        const promiseResponses = await Promise.all([
            getBootType(),
            getWorkloadKeyResourceDWInfo(),
            getNetworkBootTypeUsingModulePing(),
        ]);

        networkBootType = promiseResponses[0];
        workloadKeyResourceDWInfo = promiseResponses[1];
        moduleNWBootTypeDetails = promiseResponses[2];
    } catch (errorInPromises) {
        networkBootType = 'Unknown';
    }

    // Custom payload which will be now logged for powering analysis
    const payloadForAnalysis = {
        /**
         * Network boot type
         */
        nbt: networkBootType,

        /**
         * Was page hidden earlier than the current LCP entry
         */
        wph: false,

        /**
         * Is page currently hidden and this LCP entry has been logged due to clearing buffer scenario
         */
        iph: false,

        /**
         * Module network boot type
         */
        mnbt: moduleNWBootTypeDetails?.bootType,

        /**
         * Module network boot type duration
         */
        mnbtd: moduleNWBootTypeDetails?.duration,

        /**
         * The download duration of workload exclusive resource
         */
        ...workloadKeyResourceDWInfo,

        /**
         * Is launched as PWA
         */
        isPWA: isPWA(),
    };

    return payloadForAnalysis;
};
